<section class="section-wrapper">
  <h2 class="cam-heading">{{content?.['b2b.manageapproval.amtitle']}}</h2>
  <div [class]="isWorkflowSettingRoute?'section-context':''">
    <div class="menu-left-content" *ngIf="isWorkflowSettingRoute">
      <app-menu-nav-listing></app-menu-nav-listing>
    </div>

    <div [class]="isWorkflowSettingRoute?'right-content':''">

      <!-- Normal routed pages -->
      <ng-container *ngIf="!isListing; else approvalListing">
        <router-outlet></router-outlet>
      </ng-container>

      <!-- Approval listing -->
      <ng-template #approvalListing>
        <app-waiting *ngIf="isWaiting"></app-waiting>
        <app-approval-listing
          *ngIf="approvalList.length > 0 && !isWaiting"
          [approvalList]="approvalList"
          (itemDeleted)="loadApprovalList()">
        </app-approval-listing>
      </ng-template>

      <ng-container *ngIf="approvalList.length==0 && !isWorkflowSettingRoute && !isWaiting">
        <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="content?.['b2b.manageapproval.noworkflows']"
          [content]="content?.['b2b.manageapproval.configureworkflows']" [navigateTo]="'workflow-setting'">
        </app-cam-empty-state>
      </ng-container>

    </div>
  </div>

</section>